import { LogoMark } from "./Logo";
import { CONTACT } from "@/lib/site";

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-white/10 pb-28 pt-16">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col justify-between gap-8 md:flex-row">
        <div className="flex items-center gap-4">
          <LogoMark className="h-12 w-12" />
          <p className="max-w-xs text-sm text-slate-400">Pulizie civili e industriali a {CONTACT.area}.</p>
        </div>
        <div className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400">
          <p>{CONTACT.phone}</p>
          <p className="mt-2">{CONTACT.email}</p>
        </div>
      </div>
      <p className="mt-16 select-none font-display text-[18vw] font-extrabold leading-[0.8] tracking-[-0.05em] text-stroke lg:text-[15rem]" aria-hidden="true">Mister.</p>
      <p className="mt-8 text-xs text-slate-400">© {new Date().getFullYear()} Mister Multiservice · P.IVA {CONTACT.vat}</p>
    </div>
  </footer>
);
